var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer mt-auto py-3 border-top d-flex flex-wrap justify-content-center",attrs:{"id":"sticky-footer"}},[_c('div',{staticClass:"text-left"},[_c('span',{staticClass:"text-muted text-start"},[_vm._v("Küchentime © "+_vm._s(new Date().getFullYear()))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bfc5408","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 693
// module chunks = 43